import React, {Component, Fragment} from 'react';
import {Button} from 'reactstrap';
import autobind from 'autobind-decorator';
import Dialog from 'apa/containers/Dialog';
import {connect} from 'react-redux';
import { BaseUrl } from '../BaseUrl/BaseUrl';

@connect(
    state => ({
      auth: state.apa,
    })
)
export default class DeleteDocument extends Component {
    constructor(props) {
        super(props);
        this.state = {
            isModalOpen: false
        }
    }

    @autobind
    toggleModal() {
        this.setState(
            {
                ...this.state,
                isModalOpen: !this.state.isModalOpen
            }
        );
    }

    @autobind
      confirm() {
      this.toggleModal();
        const headers = {'Content-Type': 'application/json'};
        headers['Authorization'] = `Token ${this.props.auth.token}`;
        fetch(
            `${BaseUrl}/api/customers/documents/${this.props.documentId}/`,
            {headers, method: 'DELETE'}
        ).then(
            () => {
                window.location.reload()
            }
        );
    }

    render() {
        return (
            <Fragment>
                <Button onClick={this.toggleModal} color='danger'>
                    <i className='fa fa-times'> </i>
                </Button>
                <Dialog
                    toggle={this.toggleModal}
                    confirm={this.confirm}
                    isOpen={this.state.isModalOpen}
                    title={'Dokument löschen'}
                >
                    Sind Sie Sicher?
                </Dialog>
            </Fragment>
        )
    }
}
